(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');
    module.controller('AgendaListsUrgentController', ['SharedAgendaService', 'AgendaOverviewService', AgendaListsUrgentControllerFn]);

    /* controller for agenda list - urgent */
    function AgendaListsUrgentControllerFn(SharedAgendaService, AgendaOverviewService) {
        var vm = this;

        // current agenda 
        vm.agenda = null;

        activate();

        /* activation work */
        function activate() {            

            // allow shared agenda-switch
            SharedAgendaService.allow();

            // current agenda
            vm.agenda = SharedAgendaService.data.currentAgenda;

        }
    }
})();